module.exports = __webpack_public_path__ + "static/media/nine.fe5d4ca2.svg";